import { render, staticRenderFns } from "./CardLocked.vue?vue&type=template&id=f2e88112&scoped=true&"
import script from "./CardLocked.vue?vue&type=script&lang=js&"
export * from "./CardLocked.vue?vue&type=script&lang=js&"
import style0 from "./CardLocked.vue?vue&type=style&index=0&id=f2e88112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e88112",
  null
  
)

export default component.exports